import Index from "@/Controller/Index";
window.app = new Index;
